import { Feed, FeedEntityTypeEnum } from "@vviinn/user-managment-client-ts";
import { RenderFieldProps } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/SlideOverFieldsGroups/types";
import { FeedKey } from "./types";

export const EMPTY_FEED: Feed = {
  url: "",
  entityType: "product",
  productTypePrefix: "",
  idPrefix: "",
};

const feedTextKeys: Partial<FeedKey>[] = [
  "url",
  "productTypePrefix",
  "idPrefix",
];

const feedTypes: FeedEntityTypeEnum[] = ["product", "content", "list"];

export const feedRenderProps: RenderFieldProps<FeedKey>[] = [
  { key: "entityType", options: feedTypes, title: "Feed Type" },
  ...feedTextKeys.map((key) => ({ key })),
];

export const FEED_REQUIRED_UNIQUE_KEYS: FeedKey[] = ["url"];
